import { Component, OnInit, Input } from '@angular/core';
import { Category, Tutorial } from '@app/training/model/training.model';
import { TrainingStore } from '@app/training/services/training.store';
import { TranslateService } from '@ngx-translate/core';
import { LOCALE_ES } from '@app/@core/constants/common.constants';

@Component({
  selector: 'scf-pills-tutorial-categories',
  templateUrl: './pills-tutorial-categories.component.html',
  styleUrls: ['./pills-tutorial-categories.component.scss'],
})
export class PillsTutorialCategoriesComponent implements OnInit {
  @Input() category: Category;
  @Input() language: string;

  tutorialList: Tutorial[] = [];

  constructor(private trainingStore: TrainingStore, private translateService: TranslateService) {}

  ngOnInit() {
    if (this.category && this.language) {
      this.trainingStore
        .getTutorials(this.category.id, this.language)
        .then(
          (data) => (data ? (this.tutorialList = data) : null),
          (error) => console.error(error)
        )
        .catch((error) => console.error(error));
    }
  }
}
